import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, Text, TextAlign, TextButton, units } from '@calm-web/design-system';

import lockIcon from 'icons/lock-outline.svg';

export const Wrapper = styled.li`
	display: flex;
	align-items: center;
	position: relative;
	padding: ${units(2.75)} 0;

	&:not(:last-child):after {
		position: absolute;
		content: '';
		left: 0;
		bottom: 0;
		width: 100%;
		border-bottom: 2px solid ${palette('whiteAlpha10')};
	}
`;

export const ClickableWrapper = styled(TextButton).attrs({
	textColor: 'white',
	hideUnderline: true,
})<{
	isAvailable: boolean;
}>`
	flex: 1;
	opacity: ${p => (p.isAvailable ? '1' : '0.8')};
	cursor: ${p => (p.isAvailable ? 'cursor' : 'pointer')};
	pointer-events: ${p => (p.isAvailable ? 'auto' : 'none')};
`;

export const GuidePosition = styled.svg`
	flex: 0 0 16px;
	height: 16px;
	margin-right: 8px;
	position: relative;
	top: 2px;
	width: 16px;

	& path {
		fill: ${palette('white')};
	}
`;

export const Title = styled(Text).attrs((p: { $isPlaying: boolean }) => ({
	size: FontSizes.base,
	align: TextAlign.Left,
	el: 'div',
	color: p.$isPlaying ? 'gold' : 'white',
	weight: FontWeights.Demi,
}))<{
	$isPlaying: boolean;
}>``;

export const Duration = styled(Text).attrs({
	size: FontSizes.sm,
	align: TextAlign.Left,
	el: 'div',
	color: 'whiteAlpha60',
})``;

export const LockIcon = styled(lockIcon)`
	flex: 0 0 24px;
	height: 24px;
	position: relative;
	width: 24px;
	z-index: 5;

	& path {
		fill: ${palette('white')};
	}
`;
